import React, { useEffect, useState, useRef } from "react";
import Header from "../common/Header";
import { useParams } from "react-router-dom";
import apiCall from "../common/Utils/helper";
import SliderPopup from "./SliderPopup";
import useMetaTags from "../common/Utils/useMetaTags";

const Gallery = () => {
  const [galleryData, setGalleryData] = useState([]);
  const [showSlider, setShowSlider] = useState(false);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [allDataFetched, setAllDataFetched] = useState(false);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [folderName, setFolderName] = useState("second");
  const [ogImagePath, setOgImagePath] = useState(null);
  const { folderId } = useParams();

  useMetaTags({
    title: folderName !== "second" ? folderName : null,
    description: folderName !== "second" ? folderName : null,
    ogImage: ogImagePath,
  });
  const galleryRef = useRef(null);
  const loadMoreButtonRef = useRef(null);

  const handleCancel = () => {
    setShowSlider(false);
  };

  const fetchData = async () => {
    if (loading || allDataFetched) return;
    setLoading(true);

    try {
      const result = await apiCall("post", "/getdatabyfolder", {
        folderId,
        offset,
      });
      if (result.resultFlag === 1) {
        // Set gallery data
        setGalleryData((prevData) => [...prevData, ...result.response.files]);

        const newFolderName =
          result.response.files.length > 0
            ? result.response.files[0].folder_name
            : (galleryData.length > 0 ? galleryData[0].folder_name : null);
        setFolderName(newFolderName);

        if (offset === 0 && result.response.files.length > 0) {
          setOgImagePath(
            `https://appvideos.narendramodi.in/v2/${result.response.files[0].file_path}?im=Resize,width=1200`
          );
        }

        setOffset((prevOffset) => prevOffset + result.response.files.length);

        if (result.response.files.length === 0 || result.response.files.length < 19) {
          setAllDataFetched(true);
        }
      } else {
        console.error("Failed to retrieve data for folder:", result.message);
      }
    } catch (error) {
      console.error("Error fetching data for folder:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Intersection Observer for modern browsers
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading && !allDataFetched) {
          fetchData();
        }
      },
      { threshold: 1 }
    );

    if (galleryRef.current && !allDataFetched) {
      observer.observe(galleryRef.current);
    }

    // Scroll event listener fallback for older browsers
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 100 &&
        !loading &&
        !allDataFetched
      ) {
        fetchData();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (galleryRef.current && !allDataFetched) {
        observer.unobserve(galleryRef.current);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [folderId, offset, loading, allDataFetched]);

  const handleLoadMore = () => {
    if (!loading && !allDataFetched) {
      setLoading(true);
      fetchData();
    }
  };

  return (
    <>
      <Header folderName={folderName} />
      <div className="list_section" ref={galleryRef}>
        <div className="photonav_container">
          <ul className="photo_gallery_list">
            {galleryData.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setSliderIndex(index);
                  setShowSlider(true);
                }}
              >
                <img
                  src={`https://appvideos.narendramodi.in/v2/${item.file_path}?im=Resize,width=350`}
                  onError={(e) => { e.target.src = `https://new-dam-java.b-cdn.net/${item.file_path}?width=350` }}
                  alt={item.file_name}
                  className="gallery_image"
                />
              </li>
            ))}
          </ul>
        </div>
        {!allDataFetched && (
          <button
            ref={loadMoreButtonRef}
            onClick={handleLoadMore}
            style={{
              backgroundColor: "blue",
              color: "white",
              borderRadius: "5px",
              padding: "10px 20px",
              margin: "auto",
              display: "block",
              marginTop: "20px",
              cursor: "pointer",
            }}
          >
            Load More
          </button>
        )}
      </div>
      {showSlider && (
        <SliderPopup
          galleryData={galleryData}
          initialIndex={sliderIndex}
          onCancel={handleCancel}
          folderName={folderName}
        />
      )}
    </>
  );
};

export default Gallery;
